<template>
  <div class="flex justify-center p-4 mt-8 ">

    <div class="font-light text-gray-700 leading-loose max-w-xl">

      <p class="font-extrabold"> Allgemeine Geschäftsbedingungen für die Nutzung der VomHof-Website</p>

      <p>Herzlich willkommen in unserem Online Shop, der Produkte vom Hof aus Deiner Nähe zu Dir nach Hause bringt. <br>

        Wenn Du in unserem Shop bestellst, gelten folgende Bestimmungen:</p>

      <p
        class="font-extrabold underline my-3"
        @click="anbieter = !anbieter"
      >1 Anbieter</p>
      <p
        class="font-hairline my-2"
        v-if="anbieter"
      >Anbieter des Services ist die Quantophant GmbH, Birkenweg 37, 83209 Prien am Chiemsee. Geschäftsführungen: Nadine und Tobias Wischmeier ( Amtsgericht Traunstein HRB 26475 UstId: 315749622) </p>
      <p
        class="font-extrabold underline my-3"
        @click="angebot = !angebot"
      >2 Angebot </p>
      <p
        class="font-hairline my-2"
        v-if="angebot"
      >Unser Angebot richtet sich ausschließlich an den Endverbraucher. Wir beliefern keine Großhandelskunden, da wir die Identität und die Individualität unserer Partner (Direktvermarkter und kleine Anbieter lokaler Produkte) erhalten und fördern möchten. Wir distanzieren uns vom Massentierhaltung und industrieller Produktion. Wir behalten uns vor, die Zusammenstellung und Lieferung abzulehnen, wenn es sich bei einem Kunden um ein Großhandelsunternehmen handelt. Wir liefern nur haushaltsübliche Mengen aus. </p>
      <p
        class="font-extrabold underline my-3"
        @click="vertrag = !vertrag"
      >3 Kaufvertragsabschluss und Ablehnung</p>
      <p
        class="font-hairline my-2"
        v-if="vertrag"
      >
        Durch Inanspruchnahme dieses Services kommt noch kein Kaufvertrag zwischen dem Kunden und der Quantophant GmbH zustande. Die Online-Übermittlung der Artikelauswahl durch den Kunden stellt also insbesondere kein Angebot auf Abschluss eines Kaufvertrages dar, sondern sie ist für den Kunden völlig unverbindlich und verpflichtet ihn nicht zum Kauf der ausgewählten Artikel. Der Kunde kann uns jederzeit mitteilen, dass er die Lieferung der ausgewählten Artikel doch nicht mehr wünscht. Der Kunde hat vielmehr bis zur Annahme der Ware bei der Lieferung jederzeit die Möglichkeit, von einem Kauf der zusammengestellten Waren abzusehen. Wir nehmen die Produkte dann wieder mit und erstatten den Betrag, der vorher online entrichtet wurde.

        Wir bieten die Waren unter Beachtung der einschlägigen rechtlichen Vorgaben an. Dabei erhalten wir die produktspezifischen Informationen vom jeweiligen Direktvermarkter oder Anbieter.
      </p>
      <p
        class="font-extrabold underline my-3"
        @click="leistungen = !leistungen"
      >4 Unsere Leistungen </p>
      <p
        class="font-hairline my-2"
        v-if="leistungen"
      >Wir holen die vom Kunden online getroffene Artikelauswahl von unseren Partnern (Direktvermarkter) ab und liefern sie an die vom Kunden angegebene Adresse (bis zur Wohnungstür).

        Die Lieferung erfolgt ausschließlich in der angegebenen Liefer-Region. </p>
      <p
        class="font-extrabold underline my-3"
        @click="verfuegbarkeit = !verfuegbarkeit"
      >5 Verfügbarkeit </p>
      <p
        class="font-hairline my-2"
        v-if="verfuegbarkeit"
      >
        Wir arbeiten mit regionalen und damit auch saisonalen Produkten. Unsere Partner sind bemüht, ihr Angebot im Online Shop Angebot aktuell zu halten. Dennoch kann es vorkommen, dass einzelne Produkte gerade nicht verfügbar sind. Wir werden dann eine Alternative anbieten oder den Kaufpreis erstatten.
      </p>
      <p
        class="font-extrabold underline my-3"
        @click="mengen = !mengen"
      >6 Mengenangaben </p>
      <p
        class="font-hairline my-2"
        v-if="mengen"
      >
        Die Direktverarkter arbeiten nicht mit industriell genormten Messmethoden. Bei nicht kalibrierter Ware (insbesondere aus den Bereichen Obst, Gemüse und Käse) wird sich der Direktvermartker bemühen, solche Packungen auszusuchen, deren Inhalt der vom Kunden gewünschten Menge weitest möglich entspricht. Wir garantieren kein Genauigkeit auf Gramm-Ebene und bitten hier um Dein Verständnis.
      </p>
      <p
        class="font-extrabold underline my-3"
        @click="termine = !termine"
      >7 Liefertermine </p>
      <p
        class="font-hairline py-2"
        v-if="termine"
      >
        Wir liefern jeweils am Nachmittag ab 16 Uhr und stellen die Ware vor Deiner Wohnungstür ab.
      </p>
      <p
        class="font-extrabold underline my-3"
        @click="mindestbestellwert = !mindestbestellwert"
      >8 Mindestbestellwert </p>
      <p
        class="font-hairline my-2"
        v-if="mindestbestellwert"
      >
        Der Mindestbestellwert liegt bei 15 Euro pro Lieferung.

      </p>
      <p
        class="font-extrabold underline my-3"
        @click="datenschutz = !datenschutz"
      >9 Datenschutz </p>
      <p
        class="font-hairline my-2"
        v-if="datenschutz"
      >
        Wir erheben, verarbeiten und nutzen Deine personenbezogenen Daten, soweit dies für die Begründung, Durchführung oder Beendigung dieses Vertrags erforderlich ist. Eine weitergehende Erhebung, Verarbeitung und Nutzung deiner personenbezogenen Daten erfolgt nur, soweit eine Rechtsvorschrift dies erlaubt oder Du eingewilligt hast Hier geht's zu unserer <router-link
          to="/dataprotection"
          class="font-bold"
        >Datenschutzerklärung</router-link> .
      </p>
      <p
        class="font-extrabold underline my-3"
        @click="jugendschutz = !jugendschutz"
      >10 Jugendschutz </p>
      <p
        class="font-hairline my-2"
        v-if="jugendschutz"
      >
        Entsprechend dem Jugendschutzgesetz liefern wir alkoholische Getränke nur an Personen ab dem vollendeten 18. Lebensjahr. Wir behalten uns eine jeweilige Prüfung vor. Mit dem Bestellen auf der Grundlage unserer Allgemeinen Geschäftsbedingungen erklärst Du, dass Du volljährig und voll geschäftsfähig bist. Soweit nicht volljährige Personen Bestellungen unter Angabe falscher Tatsachen und/oder ohne Genehmigung ihrer sorge- beziehungsweise vertretungsberechtigten volljährigen Verantwortlichen veranlassen, widerruft die Quantophant GmbH diese Verträge hiermit vorsorglich gemäß § 111 BGB.
      </p>
      <p
        class="font-extrabold underline my-3"
        @click="gerichtsstand = !gerichtsstand"
      >11 Gerichtsstand </p>
      <p
        class="font-hairline my-2"
        v-if="gerichtsstand"
      >
        Für sämtliche Streitigkeiten, die in Zusammenhang mit der Anbahnung, Ausführung oder Abwicklung unseres Services entstehen, gilt ausschließlich deutsches Recht, sofern nicht zwingende verbraucherschützende Vorschriften des Landes, in dem Du Deinen gewöhnlichen Aufenthalt hast, Vorrang haben.
        Die Anwendung des UN-Kaufrechts ist ausgeschlossen. Ist der Vertragspartner ein Kaufmann, eine juristische Person des öffentlichen Rechts oder ein öffentlich-rechtliches Sondervermögen, wird als ausschließlicher Gerichtsstand unser Geschäftssitz (Traunstein) für alle Ansprüche, die sich aus oder aufgrund dieses Vertrages ergeben, vereinbart. Gleiches gilt gegenüber im Klageweg in Anspruch zu nehmenden Personen, die keinen allgemeinen Gerichtsstand in Deutschland haben oder gegenüber im Klageweg in Anspruch zu nehmenden Personen, die nach Abschluss des Vertrages ihren Wohnsitz oder gewöhnlichen Aufenthaltsort außerhalb von Deutschland verlegt haben oder deren Wohnsitz oder gewöhnlicher Aufenthaltsort im Zeitpunkt der Klageerhebung nicht bekannt ist. Von dieser Gerichtsstandsvereinbarung ausgenommen ist der gesetzliche Gerichtsstand des Mahnverfahrens.
      </p>
      <p
        class="font-extrabold underline my-3"
        @click="salvator =!salvator"
      >12 Salvatorische Klausel </p>
      <p
        class="font-hairline my-2"
        v-if="salvator"
      >
        Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein, so bleiben die AGB im Übrigen wirksam.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      anbieter: false,
      angebot: false,
      vertrag: false,
      leistungen: false,
      verfuegbarkeit: false,
      mengen: false,
      termine: false,
      mindestbestellwert: false,
      datenschutz: false,
      jugendschutz: false,
      gerichtsstand: false,
      salvator: false
    };
  }
};
</script>

<style lang="scss" scoped>
</style>